<template>
  <el-row
    :gutter="24"
    style="margin-bottom: 0"
  >
    <el-col
      :span="spanColumn"
      class="col-full"
    >
      <div class="label">{{ label ? label : '\u00A0' }}</div>

      <el-select
        v-model="selectedValue"
        placeholder="Seleccionar sentido de bobinado"
        :popper-class="'sentido-dropdown'"
        :filterable="filterable"
        :disabled="disabled"
        :size="size"
        class="ancho_total"
      >
        <template #prefix>
          <el-tooltip
            v-if="selectedOption && selectedOption.ImagenURL"
            placement="top"
            effect="light"
          >
            <template #content>
              <img
                :src="selectedOption.ImagenURL"
                alt="sentido"
                class="sentido-img--preview"
              />
            </template>
            <img
              :src="selectedOption.ImagenURL"
              alt="sentido"
              class="sentido-img--small"
            />
          </el-tooltip>
        </template>
        <el-option
          v-for="item in sentidoOptions"
          :key="item.Codigo"
          :label="item.Descripcion"
          :value="item.Codigo"
        >
          <div class="sentido-option">
            <img
              :src="item.ImagenURL"
              alt="sentido"
              class="sentido-img"
            />
            <span>{{ item.Descripcion }}</span>
          </div>
        </el-option>
      </el-select>
    </el-col>
  </el-row>
</template>

<script setup>
import {
  ref,
  watch,
  onMounted,
  computed,
} from 'vue';
import { useSentidoBobinadoStore } from '@/stores/sentido_bobinado_store.js';

const props = defineProps({
  modelValue: {
    type: [Number, null],
    default: null,
  },
  spanColumn: {
    type: Number,
    default: 4,
  },
  label: {
    type: String,
    default: '',
  },
  filterable: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'default',
  },
});

const emit = defineEmits(['update:modelValue']);

const selectedValue = ref(props.modelValue);
const sentidoStore = useSentidoBobinadoStore();
const sentidoOptions = ref([]);

onMounted(async () => {
  await sentidoStore.findAllSentidoBobinadoHTTP();
  const guardado = props.modelValue;
  if (guardado && !sentidoStore.sentidoBobinadoList.some((i) => i.Codigo === guardado)) {
    await sentidoStore.findAllSentidoBobinadoHTTP({ incluir: guardado });
  }
  sentidoOptions.value = sentidoStore.sentidoBobinadoList;
});

watch(
  () => props.modelValue,
  (val) => {
    selectedValue.value = val;
  },
);
watch(selectedValue, (val) => {
  emit('update:modelValue', val);
});

const selectedOption = computed(() =>
  sentidoOptions.value.find((i) => i.Codigo === selectedValue.value),
);
</script>

<style>
.sentido-dropdown {
  min-width: 280px !important;
}
.sentido-dropdown .el-select-dropdown__item {
  height: auto;
  line-height: 1.3;
  padding: 8px 12px;
}
</style>

<style scoped>
.label {
  font-weight: 700;
  color: #111;
  margin-bottom: 4px;
}
.sentido-option {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sentido-img {
  height: 80px;
  width: auto;
  max-width: 120px;
  object-fit: contain;
  background: #fff;
  border-radius: 4px;
  flex-shrink: 0;
}
.sentido-img--preview {
  display: block;
  height: 160px;
  width: auto;
  max-width: 240px;
  object-fit: contain;
  background: #fff;
}
.ancho_total {
  width: 100%;
}
.sentido-img--small {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 4px;
}
.col-full {
  flex: 1 1 100%;
  max-width: 100%;
  width: 100%;
}
:deep(.el-select) {
  width: 100%;
  display: block;
}
/* Alineamos bien el prefix */
:deep(.el-input__prefix) {
  display: flex;
  align-items: center;
}
</style>
